
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/financial-services",
      function () {
        return require("private-next-pages/industry/financial-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/financial-services"])
      });
    }
  